<div class="check-in-signature">
  <section>
    <info-page-header label="Check-In" sublabel="Menor de edad"></info-page-header>
    <div class="check-in-signature-content">
      <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        @if (showEmailField()) {
          <div class="form__field">
            <label for="email">Email</label>
            <input id="email" type="email" formControlName="email" [class.is-invalid]="isFieldInvalid('email')" translate="no" data-wg-notranslate/>
            @if (isFieldInvalid('email')) {
              <small class="form__error">
                {{ form.get('email')?.hasError('required') ? 'Este campo es obligatorio.' : 'Introduce un email válido.' }}
              </small>
            }
          </div>
        }
        <div class="relationship-card">
          <div class="form__field">
            <label for="menor">Selecciona al menor.</label>
            <select id="menor" formControlName="menor">
              <option *ngFor="let menor of menores" [value]="menor.id" translate="no" data-wg-notranslate>
                {{ menor.nombreCompleto }}
              </option>
            </select>
          </div>
          <div class="form__field">
            <label for="parentesco">Parentesco</label>
            <select id="parentesco" formControlName="parentesco">
              <option value="" disabled>Selecciona el parentesco</option>
              <option *ngFor="let parentesco of familyRelationshipTypes" [value]="parentesco.id">
                {{ parentesco.name }}
              </option>
            </select>
          </div>
          <div class="form__field">
            <label for="adultoResponsable">Selecciona al adulto responsable.</label>
            <select id="adultoReponsable" formControlName="adultoResponsable" translate="no" data-wg-notranslate>
              <option *ngFor="let adulto of adultosResponsables" [value]="adulto.id">
                {{ adulto.nombreCompleto }}
              </option>
            </select>
          </div>
        </div>

        <app-signature-pad #signaturePad data-testid="signature-pad"></app-signature-pad>

        <label class="toggle">
          <input type="checkbox" formControlName="aceptaPrivacidad"/>
          <span class="toggle__switch" data-testid="accept-privacy-toggle"></span>
          <span class="toggle__text" data-testid="accept-privacy-text">
          He leído y doy mi consentimiento<br/>
            a la <a routerLink="/privacy-policy" class="toggle__link" (click)="storeEmail()">Política de Privacidad</a>
        </span>
        </label>

        <button type="submit" class="primary-btn" [disabled]="form.invalid" data-testid="check-in-signature-submit">
          Finalizar Check-in
        </button>
      </form>
    </div>
  </section>
</div>
